import { Injectable } from "@angular/core";
import { ApiServiceCall } from "../global.apiServicecall";
import { Observable } from "rxjs";
import { ApiUrl } from "../../constants/apiUrl";

@Injectable({
  providedIn: 'root'
})
export class PromotionsService {

   constructor(
          private serviceCall: ApiServiceCall
          ) { }

    participateFreeFoodYearPromotion(data:any): Observable<any> {
        let _url = ApiUrl.publicPromotions + '/free_food_year';
        return this.serviceCall.Post(_url, false, data);
    }
}
